import { Box, Stack, Divider, styled, Grid, Typography } from '../../../base';

export const StyledCard = styled(Stack)(({ theme }) => ({
    height: '100%',
    minHeight: 0,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
}));

export const StyledHeader = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(2),
}));

export const StyledIconBadge = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
    margin: theme.spacing(0, 3),
}));

export const StyledPreview = styled(Box)(() => ({
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
}));

export const StyledPreviewBody = styled(Box)(({ theme }) => ({
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2),
    wordBreak: 'break-word',
    unicodeBidi: 'plaintext',
    color: theme.palette.text.primary,
}));

export const StyledHtmlBody = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    unicodeBidi: 'plaintext',
}));

export const StyledPreviewFooter = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: theme.spacing(0, 0, 2, 2),
}));

export const StyledPargodaLogo = styled('img')({
    height: 24,
    width: 'auto',
});

export const StyledActionsBar = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(1, 2),
}));
